var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedcrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8934_23233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 6.57031C15.4799 6.57031 8.57227 13.4779 8.57227 21.9989C8.57227 30.5198 15.4799 37.4275 24.0008 37.4275C32.5218 37.4275 39.4294 30.5198 39.4294 21.9989C39.4194 13.4821 32.5176 6.58036 24.0008 6.57031Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9769 17.0388L19.0426 24.9731C18.4948 25.5208 18.4948 26.4089 19.0426 26.9566C19.5903 27.5044 20.4784 27.5044 21.0261 26.9566L28.9604 19.0223C29.5082 18.4746 29.5082 17.5865 28.9604 17.0388C28.4127 16.491 27.5246 16.491 26.9769 17.0388Z",
    fill: "#DE5959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0427 19.0231L26.977 26.9574C27.5247 27.5052 28.4128 27.5052 28.9605 26.9574C29.5083 26.4097 29.5083 25.5216 28.9605 24.9739L21.0262 17.0396C20.4785 16.4918 19.5904 16.4918 19.0427 17.0396C18.4949 17.5873 18.4949 18.4754 19.0427 19.0231Z",
    fill: "#DE5959"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8934_23233",
    x: 0.572266,
    y: 0.570312,
    width: 46.8574,
    height: 46.8555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8934_23233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8934_23233",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedcrossIcon);
export default __webpack_public_path__ + "static/media/redcross-icon.903121f0dc72f5a003333da29f06af33.svg";
export { ForwardRef as ReactComponent };